<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <!--    <c-callout color="secondary">-->
  {{ info | translate }}
  <c-input-group class="input-group gap-0 flex-nowrap p-2">
    <select
      id="mfaOption"
      cSelect
      formControlName="mfaOption"
      (change)="onMfaOptionChange()"
    >
      @for (option of authService.mfaOptions.options; track option) {
        <option [value]="option">
          {{ option }}
        </option>
      }
    </select>
    <button
      type="submit"
      cButton
      color="primary"
      class="align-middle"
      [disabled]="authService.submitButtonIsDisabled(this)"
    >
      @if (authService.actionInProgress(this)) {
        <c-spinner aria-hidden="true" size="sm"></c-spinner>
      }
      {{ 'AUTH_MFA_BUTTON_RESEND_CODE' | translate }}
    </button>
  </c-input-group>
  <app-alert-message [parentComponent]="this"></app-alert-message>
  <!--    </c-callout>-->
</form>
